import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextHighlight from '../TextHighlight';


class DocketEntriesTableBody extends Component {
  constructor(props) {
    super(props);
    this.domElemRef = React.createRef();
  }

  render() {
    return (
      <tbody className="docket-entries-table" ref={this.domElemRef}>
        <TextHighlight searchKeywords={this.props.keywords} getParentNode={() => this.domElemRef}>
          { this.props.rows }
        </TextHighlight>
      </tbody>
    );
  }
}

DocketEntriesTableBody.defaultProps = {
  keywords: '',
};

DocketEntriesTableBody.propTypes = {
  rows: PropTypes.node.isRequired,
  keywords: PropTypes.string,
};

export default DocketEntriesTableBody;



// WEBPACK FOOTER //
// ./src/components/case/docket/docketEntries/DocketEntriesTableBody.jsx